import { React } from 'react';

import { Route, Routes } from 'react-router-dom';

import ProtectedRoute from '../components/protectedRoutes';
import CancelarAcordo from '../pages/financeiro/cancelarAcordo';
import CheckSerasaCobranca from '../pages/financeiro/checkSerasaCobranca';
import GerarPix from '../pages/financeiro/gerarPix';
import GerarPixLitigio from '../pages/financeiro/gerarPixLitigio';
import LancarAcordo from '../pages/financeiro/lancarAcordo';
import LancarAcordoLitigio from '../pages/financeiro/lancarAcordoLitigio';
import NegativarTitulo from '../pages/financeiro/negativarTitulo';
import RecebimentoLimpaNome from '../pages/financeiro/recebimentoLimpaNome';
import SimularAcordo from '../pages/financeiro/simularAcordo';
import QuitacaoDebitos from '../pages/gestaoEnergia/quitacaoDebitos';

const RouteCobranca = () => {
    return (
        <Routes>
            <Route element={<ProtectedRoute role='Cobranca'/>}>
                <Route path='gerarPix' element={<GerarPix/>}/>
                <Route path='gerarPixLitigio' element={<GerarPixLitigio/>}/>
                <Route path='lancarAcordo' element={<LancarAcordo/>}/>
                <Route path='lancarAcordoLitigio' element={<LancarAcordoLitigio/>}/>
                <Route path='recebimentoLimpaNome' element={<RecebimentoLimpaNome/>}/>
                <Route path='quitacaoDebitos' element={<QuitacaoDebitos/>}/>
                <Route path='checkSerasaCobranca' element={<CheckSerasaCobranca/>}/>
                <Route path='negativarTitulo' element={<NegativarTitulo/>}/>
                <Route path='simularAcordo' element={<SimularAcordo/>}/>
                <Route path='cancelarAcordo' element={<CancelarAcordo/>}/>
            </Route>
        </Routes>
    );
};

export default RouteCobranca;
